import CardsContent from "./content/cards-content.jsx";
import CorporationNotifications from "./content/corporation-notifications.jsx";
import PlateNotifications from "./content/plate-notifications.jsx";
import CloneList from "./content/clone-list.js";
import SignUserNotifications from "./content/sign-user-notifications.jsx";

export default function ReportContent({ data, collapsed }) {
    return (
        <>
            <CloneList data={data} />
            <CardsContent data={data} />
            <CorporationNotifications data={data} key={`corporationNotificationsKey-${collapsed}`} />
            <PlateNotifications data={data} key={`plateNotificationsKey-${collapsed}`} />
            <SignUserNotifications data={data} key={`signUserNotificationsKey-${collapsed}`} />
            <div id="chart-tables" />
        </>
    )
}